import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import type { OneValueMeasurement } from "~/api/lastMeasurements";
import { BodyTemperature } from "~/icons";
import { formatBackendDate } from "~/utils";
import { HealthDetails } from "../";

interface BodyTemperatureProps {
  measurement: OneValueMeasurement | null;
  patientId: number;
}

export const BodyTemperatureCard = ({
  measurement,
  patientId,
}: BodyTemperatureProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const val = measurement
    ? (measurement.value / 10).toFixed(2).toString()
    : t("health.no_data");

  const handleViewMore = () => {
    void navigate(`/airmen/${patientId}/body-temperature`);
  };

  // Collapsed card view
  return (
    <HealthDetails.Card
      onClick={handleViewMore}
      className="cursor-pointer transition-shadow duration-200 hover:shadow-lg"
    >
      <HealthDetails.CardHeader>
        <BodyTemperature className="text-primary-40 dark:text-primary-80" />
        <HealthDetails.CardTitle>
          {t("health.body_temperature")}
        </HealthDetails.CardTitle>
      </HealthDetails.CardHeader>
      <HealthDetails.CardBody>
        <HealthDetails.CardResult>{val}</HealthDetails.CardResult>
        <HealthDetails.CardDetails>
          <HealthDetails.CardUnit>
            {t("health.degrees_fahrenheit")}
          </HealthDetails.CardUnit>
          {measurement && (
            <HealthDetails.CardDate>
              {formatBackendDate(measurement.date)}
            </HealthDetails.CardDate>
          )}
        </HealthDetails.CardDetails>
        <div className="flex flex-1 items-center justify-end">
          <button className="text-sm text-primary-40 transition-colors hover:text-primary-30 dark:text-primary-80 dark:hover:text-primary-90">
            {t("general.view_more")}
          </button>
        </div>
      </HealthDetails.CardBody>
    </HealthDetails.Card>
  );
};
